module.exports = __webpack_public_path__ + "img/wechat_pay.8a2e80b4.png";